<template>
  <div class="video-comment">

    <!-- 学习人数、好评、报名 -->
    <div class="comment-top">
      <ul>
        <li class="line">
          <span>{{onlineNum}}</span>
          <span>人在学习</span>
        </li>
        <li>
          <span></span>
          <span>{{goodFeedback}}%好评</span>
        </li>
        <li>
          <div class="block">
            <el-rate disabled v-model="value" :colors="colorsColor">
            </el-rate>
          </div>
        </li>
      </ul>
      <!-- 非点播 -->
      <div v-if="cloudClassData.type!=2" class="remind-btn">

        <!-- 报名 -->
        <div v-if="playBackList.length==0&&cloudClassData.state==0">
          <span v-if="intoCloudData.applyNum">{{intoCloudData.applyNum}}人已报名</span>
          <el-button v-if="isSignUp" @click="_signUpBtn('1')" type="primary">我要报名</el-button>
          <el-button v-if="isSignUp" :disabled="isSignUp" type="primary">您已报名</el-button>
        </div>

        <!-- 回看提醒 -->
        <div v-if="playBackList.length==0&&(cloudClassData.state==3||cloudClassData.state==2||cloudClassData.state==1)">
          <el-button @click="_signUpBtn('2')" type="primary">回看提醒</el-button>
        </div>

        <!-- 直播已结束 立即学习 -->
        <div v-if="playBackList.length!=0&&cloudClassData.state==3">
          <span>直播已结束</span>
          <el-button type="primary">立即学习</el-button>
        </div>
      </div>
    </div>

    <!-- 课程简介、评价、老师简介 -->
    <div class="course">
      <el-tabs v-model="activeName">

        <el-tab-pane label="课程简介" name="first">
          <span v-html="cloudClassData.content">
          </span>
        </el-tab-pane>

        <el-tab-pane label="课程评价" name="second">

          <!-- 评论 -->
          <div class="review-item" v-for="(item,index) of currentMarkList" :key="index">
            <img class="review-item-img" src="~@/assets/img/topNav/logo.png" alt="">
            <div class="review-item-msg">
              <span>{{item.name}}</span>
              <span>{{item.createTime}}</span>
              <div class="block">
                <el-rate disabled v-model="item.score" :colors="colorsColor">
                </el-rate>
              </div>
            </div>

            <div class="review-content">
              {{item.appraise}}
            </div>
          </div>

          <!-- 加载更多评论 -->
          <div class="add-review">
            <span v-if="!isAddMark" @click="addMark">点击查看更多评论</span>
            <span v-if="isAddMark&&currentNum==0">评论已加载完！！</span>
          </div>

          <!-- 发表评论 -->
          <div class="review-input">
            <el-input @keydown.native="appraiseKeyCode($event)" :show-word-limit='true' :minlength='4' :maxlength='500'
              type="textarea" :readonly='isReadonly' :rows="2" resize='none' :placeholder="placeholderMsg"
              v-model="appraiseMsg">
            </el-input>

            <div class="review-button">
              <div class="block">
                <el-rate v-model="score" :colors="colorsColor">
                </el-rate>
              </div>
              <el-button @click="appraiseBtn" :disabled="isReadonly" type="success">发表</el-button>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="老师简介" name="third">
          <span>
            {{intoCloudData.teacherInfo}}
          </span>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { myMsg, action, classEvaluate } from "@/network/cloudRequest/api";
import utils from "@/util/index";

export default {
  name: "VideoComment",
  props: {
    //进入课程数据（进入课堂接口获取）--------------------------------------------
    intoCloudData: {},
    //课程信息--------------------------------------------
    cloudClassData: {},
    //在线人数--------------------------------------------
    onlineNum: {}
  },

  data() {
    return {
      //好评数--------------------------------------------
      goodAppraise: 0,
      //评论数组--------------------------------------------
      markList: [],
      //判断是否评价过--------------------------------------------
      isAppraise: false,
      //好评评分--------------------------------------------
      value: 0,
      //星级颜色--------------------------------------------
      colorsColor: ["#24ba58", "#24ba58", "#24ba58"],
      //视频回放列表--------------------------------------------
      playBackList: [],
      //该课程是否报名--------------------------------------------
      isSignUp: false,
      //当前选项--------------------------------------------
      activeName: "first",
      //当前评价数量--------------------------------------------
      currentNum: 4,
      //当前评价列表--------------------------------------------
      currentMarkList: [],
      //评价输入框的数据--------------------------------------------
      appraiseMsg: "",
      //评论星数--------------------------------------------
      score: 4
    };
  },


  methods: {
    init() {
      //初始化好评数--------------------------------------------
      this.getMarkList();
      //是否报过名--------------------------------------------
      this.getSignUp();

      //视频回放列表--------------------------------------------
      this.playBackList = this.intoCloudData.videoList;
    },

    //获取好评数--------------------------------------------
    getMarkList() {
      if (this.intoCloudData.markList) {
        this.markList = this.intoCloudData.markList.reverse();
        this.currentMarkList = this.markList.slice(0, 4);
        //判断用户该用户是否评价过
        this.intoCloudData.markList.forEach(item => {
          //好评数量
          if (item.score > 3) {
            this.goodAppraise += 1;
          }
          //判断是否评价过
          if (item.id == this.$store.state.userId) {
            this.isAppraise = true;
          }
        });
      }
    },

    //是否报过名--------------------------------------------
    getSignUp() {
      //登录了才去判断
      if (this.$store.state.userId == "") {
        //判断是否报过名
        let data = {
          //页码
          pageNum: "0",
          //当前页面数量
          pageSize: "0",
          //用户id
          subjectId: this.$store.state.userId,
          //用户类型 0=学生 1= 教师
          subjectType: "0",
          //0=收藏 ，1=课程
          type: "1"
        };

        myMsg(data).then(res => {
          if (res.data.success)
            res.data.data.list.forEach(item => {
              if (item.id == this.cloudClassId) {
                this.isSignUp = true;
              }
            });
        });
      }
    },

    //报名+收藏该课程按钮
    _signUpBtn(type) {
      if (this.$store.state.isLogin) {
        let dateTime = new Date().getTime();
        let fd = new FormData();
        fd.append("actionDate", utils.timeFormat(dateTime));
        //	0=教材收藏，1=课件收藏，2=图书收藏，3=题库收藏， 4=课堂
        fd.append("collectType", "4");
        fd.append("comment", "课堂");
        fd.append("id", this.$route.query.cloudClassId);
        fd.append("subjectId", this.$store.state.userId);
        fd.append("subjectType", "0");
        //操作类型（0=收藏，1=报名，2=回看提醒）
        fd.append("type", type);
        //未收藏过则进来
        if (type) {
          action(fd).then(res => {
            if (res.data.success) {
              if (type == "1") {
                this.isSignUp = true;
                utils.tips("success", "报名成功");
              }

              if (type == "2") {
                utils.tips("success", "回看提醒设置成功");
              }
            }
          });
        }
      } else {
        utils.tips("warning", "请您先登录");
      }
    },

    //加载更多评论
    addMark() {
      this.currentNum += 4;
      this.currentMarkList = this.markList.slice(0, this.currentNum);
    },

    //enter发送评价`
    appraiseKeyCode(e) {
      let code = e.keyCode;
      let shift = e.shiftKey;
      if (code == "13" && !shift && !this.isAppraise) {
        e.preventDefault();
        this.appraiseBtn();
      }
    },

    //发表按钮发送评价
    appraiseBtn() {
      let sensitiveWords = require("@/assets/js/sensitiveWords/sensitiveWords");
      sensitiveWords = sensitiveWords.default;
      sensitiveWords.forEach(item => {
        let reg = new RegExp(item, "g");
        if (this.appraiseMsg.indexOf(item) != -1) {
          let result = this.appraiseMsg.replace(reg, "**");
          this.appraiseMsg = result;
        }
      });

      let data = {
        cloudClassId: this.$route.query.cloudClassId,
        id: this.$store.state.userId,
        score: this.score,
        appraise: this.appraiseMsg,
        name: this.userName
      };

      if (this.appraiseMsg.length >= 4) {
        classEvaluate(data).then(res => {
          if (res.data.success) {
            this.currentMarkList.push(data);
            this.appraiseMsg = "";
            //评价成功修改评价状态
            this.isAppraise = true;
            utils.tips("success", "评价成功");
          }
        });
      } else {
        utils.tips("error", "最少输入四个字符");
      }
    }
  },

  watch: {
    intoCloudData(newVal) {
      if (newVal) {
        //数据进来进行初始化--------------------------------------------
        this.init();
      }
    }
  },

  computed: {
    //好评反馈
    goodFeedback() {
      let num = parseInt((this.goodAppraise / this.markList.length) * 100);
      this.value = num ? num / 20 : 5;
      return num ? num : 100;
    },

    //是否还可以加载更多评论
    isAddMark() {
      return this.currentNum >= this.markList.length;
    },

    //是否已经评论过
    isReadonly() {
      if (this.isAppraise) {
        return true;
      }

      if (!this.$store.state.isLogin) {
        return true;
      }
    },

    //评价时显示的信息
    placeholderMsg() {
      if (this.$store.state.isLogin) {
        if (this.isAppraise) {
          return "您已经评论过该课程！";
        } else {
          return "请文明用语！";
        }
      } else {
        return "请您先登录！";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.video-comment {
  width: 848px;

  .comment-top {
    display: flex;

    padding: 0 19px 0 27px;
    height: 76px;

    background-color: #fff;

    justify-content: space-between;
    align-items: center;

    ul {
      display: flex;

      list-style: none;

      font-family: Microsoft YaHei;
      font-size: 16px;
      font-weight: 400;
      line-height: 16px;

      color: #333;

      li {
        display: flex;

        margin-right: 15px;
        height: 33px;

        line-height: 33px;

        align-items: center;

        span:nth-child(1) {
          padding-right: 3px;

          color: #24ba58;
        }
      }

      li.line {
        border-right: 1px solid #333;

        span:nth-child(2) {
          padding-right: 15px;
        }
      }
    }

    .remind-btn {
      div {
        display: flex;

        font-family: Microsoft YaHei;

        align-items: center;
        span {
          margin-right: 10px;

          font-size: 16px;
          font-weight: 400;
          line-height: 16px;

          color: rgba(135, 135, 135, 1);
        }

        /deep/ .el-button--primary {
          border-color: #24ba58;

          background-color: #24ba58;
        }
      }
    }
  }

  //········································
  .course {
    margin-top: 20px;
    padding: 17px;
    min-height: 238px;

    font-family: Microsoft YaHei;
    font-size: 12px;
    font-weight: 400;

    color: rgba(51, 51, 51, 1);
    background-color: #fff;

    .review-item {
      position: relative;

      margin-top: 27px;
      margin-bottom: 22px;
      padding-top: 7px;
      padding-left: 45px;
      height: 94px;

      .review-item-img {
        position: absolute;
        top: 0;
        left: 0;

        border-radius: 50%;
        width: 30px;
        height: 30px;
      }

      .review-item-msg {
        display: flex;

        margin-bottom: 24px;

        align-items: center;

        span:nth-child(2) {
          margin: 0 10px;
        }
      }

      .review-content {
        border-bottom: 1px solid #efefef;
        padding-bottom: 12px;
        width: 760px;
      }
    }

    .add-review {
      display: flex;

      margin-bottom: 10px;

      align-content: center;
      justify-content: center;
      span {
        cursor: pointer;
      }
    }

    .review-input {
      position: relative;

      margin-top: 20px;
      padding: 10px 7px 8px;
      height: 156px;

      background-color: #f0edf1;

      .review-button {
        display: flex;

        position: absolute;
        right: 7px;
        bottom: 8px;

        align-items: center;

        /deep/ .el-button {
          margin-left: 3px;
          border-radius: 3px;
          padding: 0;
          width: 56px;
          height: 24px;

          color: rgba(255, 255, 255, 1);
          background: rgba(36, 186, 88, 1);

          span {
            margin: 0 auto;

            font-size: 12px;
            font-weight: 400;
          }
        }
      }

      /deep/ .el-textarea textarea {
        height: 105px;
      }

      /deep/ .el-input__count {
        right: 20px;

        background: transparent;
      }

      /deep/ .el-textarea__inner:focus {
        border-color: #24ba58;
      }
    }
  }
}
</style>